import React from 'react';
import './PlanningHero.css';

const PlanningHero = () => {
  return (
    <section className="planning-hero">
      <div className="planning-hero-overlay">
        <div className="planning-hero-content">
          <h1>Planning, Research & Statistics</h1>
          <p>Guiding development through data, partnerships, and strategic foresight.</p>
        </div>
      </div>
    </section>
  );
};

export default PlanningHero;